<script lang="ts">
  import { i18n } from "../Services/i18n";
  import LangSelect from "../Components/Shared/LangSelect.svelte"

  let allowed: boolean = true;

  /* $: checkBrowser(); */

  function checkBrowser() {
    const userAgentString = navigator.userAgent;
    // Regular expression to extract the version number for Safari
    const safariVersionRegex = /Version\/(\d+\.\d+)/;
    // Check if the user agent belongs to Safari by looking for the 'Safari' keyword and 'Version' token
    if (userAgentString.includes("iPhone")) {
        const match = safariVersionRegex.exec(userAgentString);
        if (match && match.length > 1) {
            // Extracted version number from the user agent string
            const version = parseFloat(match[1]);
            // Block access if the version is less than 16
            allowed = !(version < 16);
        }
    }
    return allowed;
    // const userAgentString = navigator.userAgent;
    // // Regular expression to extract the version number for Safari
    // const safariVersionRegex = /Version\/(\d+\.\d+)/;
    // // Check if the user agent belongs to Safari by looking for the 'Safari' keyword and 'Version' token
    // if (userAgentString.includes("Safari") && userAgentString.includes("Version/")) {
    //     const match = safariVersionRegex.exec(userAgentString);
    //     if (match && match.length > 1) {
    //         // Extracted version number from the user agent string
    //         const version = parseFloat(match[1]);
    //         // Deny access if the version is less than 17
    //         allowed = version >= 17;
    //         return;
    //     }
    // }
    // // Allow access for all other browsers
    // allowed = true;
  }
</script>

{#if allowed}
  <div class="view">
    <div class="content">
      <div class="main">
        {$i18n("Debe seleccionar una sala.")}
      </div>
      <LangSelect />
    </div>
  </div>
{:else}
  <div class="view">
    <div class="content">
      <div class="main">
        <img src='/images/icon-warning.png' alt='warning' style='width: 88px;display: block;margin-left: auto;margin-right: auto;'/>
        <div style='position: relative;'>
          <div style='display:flex; margin-top: 40px; gap: 20px;border: 1px solid white; padding: 20px; border-radius: 10px; margin-left: 5px; margin-right: 5px'>
            <img src="/images/flags/es.svg" alt="" style="position:absolute;width: 40px; height: 40px;top: 20px; left: 45%">
            <div>
              <p style="max-width:330px;text-align: center">La versión de su <!-- navegador -->dispositivo no es compatible con nuestra aplicación.</p>
              <p style="max-width:330px;text-align: center">Por favor, actualícelo<!--  o cambie de navegador -->.</p>
            </div>
            
          </div>
        </div>
        
        <div style='position:relative'>
          <div style='display:flex; margin-bottom: 50px; margin-top: 30px; gap: 20px;border: 1px solid white; padding: 20px; border-radius: 10px;margin-left: 5px; margin-right: 5px'>
            <img src="/images/flags/en.svg" alt="" style="position:absolute;width: 40px; height: 40px;top: 10px; left: 45%">
            <div>
              <p style="max-width:330px;text-align: center">The version of your <!-- browser -->device is not compatible with our app.</p>
              <p style="max-width:330px;text-align: center">Please, update<!--  or change browser -->.</p>
            </div>
          </div>
        </div>
        
      </div>
    </div>
</div>
{/if}

<style>
  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    padding: 1rem;
  }

  .main {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
